import { Button, TextField, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { ReactNode, useState, useEffect } from "react";


//import { CapacitorZebraPrinter } from "capacitor-zebra-printer";
import { Nfc, NfcUtils, NfcTagTechType, NfcTag, RecordTypeDefinition } from '@capawesome-team/capacitor-nfc';
import { Capacitor } from '@capacitor/core';

import { CapacitorBarcodeScanner, CapacitorBarcodeScannerCameraDirection, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';
import { useSnackbar } from './../snackbar';
import { findAllByTestId } from "@testing-library/react";

import axios, { Axios } from "axios";

const writeTag = async (id: string) => {
    return new Promise<void>((resolve, reject) => {
        const utils = new NfcUtils();
        const { record } = utils.createNdefTextRecord({ text: id});
        const uri = utils.createNdefUriRecord({ uri: 'https://c.rebricker.com/HU/'+id});

  
      Nfc.addListener('nfcTagScanned', async (event) => {
        await Nfc.write({ message: { records: [record, uri.record] } });
        console.log("write sucessfull")
        Nfc.removeAllListeners();
        await Nfc.stopScanSession();
        console.log("write stopped")
        resolve();
      });

      Nfc.addListener('scanSessionCanceled', async () => {
        await Nfc.stopScanSession();
        reject("cancel");
      });

      Nfc.addListener('scanSessionError', async (event) => {
        await Nfc.stopScanSession();
        reject(event);
      });
  
      Nfc.startScanSession({alertMessage: `Tag auflegen. Behälter ${id} wird beschrieben.`});
    });
  };
  
  const read = async () => {
    return new Promise<NfcTag>((resolve) => {
      Nfc.addListener('nfcTagScanned', async (event) => {
        await Nfc.stopScanSession();
        resolve(event.nfcTag);
      });
  
      Nfc.startScanSession();
    });
  };
  

const makeReadOnly = async () => {
    return new Promise<any>((resolve) => {
      Nfc.addListener('nfcTagScanned', async (event) => {
        await Nfc.makeReadOnly();
        await Nfc.stopScanSession();
        resolve(event);
      });
  
      Nfc.startScanSession();
    });
  };

interface ICreateLabels {

}

const readNextHu = async (type: string) =>  {

    console.log("readNextHu")

    const url = `https://picturama.rebricker.com/api/warehouse/handlingUnit?type=${type}&sortBy=id&orderBy=desc&limit=1`
    console.log(url)

    const response = await fetch(url);

    console.log("json")
    const data = await response.json();

    if (data.items.length > 0)
    {
        const match = data.items[0].id.match(/\d+$/);

        // Extract the number as an integer
        return parseInt(match[0], 10) + 1;
    }else{
        return 1
    }
}

const CreateLabels = (props:ICreateLabels) => {

    const showSnackbar = useSnackbar();
    const [type, setType] = useState<string>("HUST");
    const [counter, setCounter] = useState<number>(1);
    const [value, setValue] = useState<string>("");

    const [tm, setTm] = useState<string>("");

    useEffect( () =>  {  const data = async () => {setCounter(await readNextHu(type))}; data();}, [type]);


    const onClick = async (next:boolean, write:boolean, print:boolean) => {

        const utils = new NfcUtils();
        try
        {

            console.log("onclick")
            const nextCounter = next ? await readNextHu(type) : counter; 

            console.log("counter")
            const toWrite = `${type}${nextCounter.toString().padStart(6, '0')}`

            if (write )
             {

                if (!Capacitor.isNativePlatform())
                {
                    throw new Error();
                }

                do{
                    var writeCount: number = 0
    
                    try {
                        console.log("write start")
                        await writeTag(toWrite);
                        break;
                    } catch (error) {
                        console.log('error ' + error)
                        if (error == 'cancel')
                        {
                            return
                        }
                        
                    }               
                }while(true);
             }
  
              
           
            if (print)
            {
                
                if (next)
                {
                    console.log("create LAbel")
                    await fetch('https://picturama.rebricker.com/api/warehouse/handlingUnit', {
                        method: 'POST',
                        headers: {
                           'Content-Type':  'application/json'
                        },
                       body: JSON.stringify({'id':toWrite, 'type': type
   
                       })
                   });
                }
               

                console.log("print")
                const label = `^XA
^PW472
^LL315
^FO15,25^A0N,50,50^FD${toWrite}^FS
^FO15,80^BQN,2,7^FDQA,"https://eco-holi.interatio-meditec.de/t/${toWrite}"^FS
^FO260,103^GC176,3^FS
^FO320,177^A0N,36,36^FDNFC^FS
^XZ`;

const label_image = `^XA
^PW472
^LL315
^FO15,25^A0N,50,50^FD${toWrite}^FS
^FO15,80^BQN,2,6^FDQA,"https://eco-holi.interatio-meditec.de/t/${toWrite}"^FS
^FO257,103^GFA,4140,4140,23,,:::Y07KFE,X0OF,V01QF8,V0JFDNF,U07JFC720CJFE,T03IFDBCD805FEIFC,T0JF9FFC07DFCJF,S03FDFFD8K01F3DFFC,S0KFO03BIF,R03JFQ07IFC,R0JFCQ01JF,Q03JFCR021FFC,Q0IFE3CS06IF,P01IF83ES010CF8,P07FFE03ET0617E,P0IF807FU039F,O03FFE007F8T078FC,O07FF8007FCT01C7E,O0IFI0FFCU0E3F,N01FFCI0FFEU021F8,N07FF8I0FBFV01FE,N0FFEI01FBFCU04FF,M01FFCI01F7FEV07F8,M03FF8I01F7FFV07FC,M07FEJ01E7FFCU03FE,M0FFCJ03CIFEU01FF,L01FF8J03EJFV0FF8,L03FFK03EFEFFCU0FFC,L07FEK07CFCIFU07FE,L0FFCK07CFCEFF8U0FF,L0FF8K07EFFEFFEU07F,K01FFL07FFDE9FF8T07F8,K03FEL0FDFEFF3FET03FC,K07FCL0FDIFC3FF8T0FE,K0FF8L0FDFFE07IFT07F,K0FFM0JF87JFCS03F,J01FFL01FCDC3FBFBFF8R01F8,J03FEL01FBD8FFBFCIFS07C,J03FCL03LFBKFCR07C,J07F8L03BKFDLFR03E,J0FF8L037KFDFFEIFEP011F,J0FFM03LFDIFE7FF8P09F,I01FEM07PFE7FFEP04F8,I03FCM07IF9LFE71FF8O047C,I03FCM07LFEKF0BFEO023C,I07F8M0MFEFDBFF01FF8O01E,I07F8M0MFDFD3A0081FEP0E,I0FFN0LFDIF667080FF8N0C7,I0FFM01PFBE70027FEN0E7,001FEM01JFB7FDFBBE7I07FF8I04080738,001FEM01FBFF7FFDF9BEE0C837FF800E300638,003FCM01MFCIFEF0081JF7DECI0DC,003FCM03KF9FBCF8CFI0CMFI03FC,003F8M03KFB7FEI0C0C89LFEI017C,007F8M03EL03F1AN0JFEI017E,007FN03EM073EN086DE2J0FE,00FFN03EM017EN0A43CK0CF,00FEN03EN07EN0303CK01F,00FEN03EN07EN0C1DCK07F,01FEN03EN03EN0C978K07F8,01FCN07EN01EO0C38K0378,01FCN07EN016N08078K0238,03FCN07EO0EP078K023C,03F8N07EI0FFJ0EN0803L01FC,03F8N0FEI0FFCI0E001KF803L01BC,03F8N0FEI0FFCI0EI0KF007L013C,07F8N0FEI0FFEI0EI0KF00FL013E,07FN01FEI0FFEI0EI0DFDEC00FM09E,07FN01FEI0FFEI0EI08FDE600FM09E,07FN03FEI0FBE001EI0BDCC0C07M0BE,07FN03FEI0FFC001EN0817M07E,0FEN07F6I0FFI01EN081FM07F,0FEN0FFEN03EN081FM06F,0FEN0FFEN07EP0FM07F,0FEM01FFEN0FEO03EM077,0FEM03FFEM01FEM018CEM073,0FEM03FFEM03FEM01C0EM073,0FEM07FFEM01FEN090EM067,0FCM07FFEN0FEN01CEM023,1FCM0FFBEN07EM01A3EM0238,1FCL03FF9EN03EI0KF31EM0278,1FCL07IFEI0FEI03EI0KF20EN078,1FCK01IFEEI0FF8001EI0FFDF800EM0278,1FCK03IFCEI0FFC001EI0E3F94F56M0338,1FCK07IFDEI0FFC001EI0CIF677EM0338,1FCK0KFEI0FFC001EI0BDDE4076M0338,1FCK0KFEI0FFC001EI0FFC2003EM0278,1FCK0KFEI0FFC001EI0EJ01EEM0238,1FCK0KFEI0FFC001EN03EEM0278,1FCK0KFEI0FFC001EN01EEM0278,1FCJ01DJFEI0FFC001EP0EM0338,1FCJ01FF4EFEI0FFC001EN079CM0378,1FCJ01IF0FEI0FBC001EN07DCM0278,1FCJ03IFE1EI0FBE001EN07CCM02F8,0FEJ03KFEI0F7E001EN07DCM07F,0FEJ07KFEI0F7E001EN07FCM07F,0FEJ0FE0IFEI0EFEI0EN07B8M07F,0FEJ0FC01RF7NF9B8M07F,0FEI01FC00LFBTF938M07F,0FEI01FC003JFE1KFDDKFEDB18M07F,0FEI03F8001FEJ03E0C0C0F020780F38M07F,07FI03F8001FCJ03E0C0C07820703E7N0FE,07FI07FJ0FEJ03E0C0C03820607DFN0FE,07FI07FJ07EE0401E0C0C0386040FBFN0FE,07FI07FJ07FE0F83E0C0C0386041C3EN0FE,07FI07EJ03FE0F8360C0C0182003C7EN0FE,03F800FEJ01FE078I0C0C0182003DFEM01FC,03F800FEJ01FE078I0C0C0082003BFEM01FC,03F800FEK0FE078I0C0C10860013FEM01FC,03FC00FCK0FE078I0C0C1006I03FEM03FC,01FC00FCK07E0783E0C0C1802040DFEM03B8,01FC00FCK07E0783E0C0C18020606FCM03F8,01FE00F8K03E0783E0C0C1C0206077CM0278,00FE00F8K03E0783E0C0C1C020703FCM077,00FE007L03E0783E0E0C1E020781FCM077,00FF006L01E0783E0C0C1E020781FCM0F7,007FO01F0F83E0E0E3F070FC0FCM0F6,007FO01YFCM0C6,007F8N01YFCL01FE,003F8N01OFDIFBKFCL01FC,003FCN03OFEFFE7JFBCL03FC,001FCN03OFE3FDKFBCL03F8,001FEI07FI03PF0E3IFCF3CL0738,I0FE001IF003F3NFE0FFEFFEFCL073,I0FF001IFC07OFDF1KF7DCL0E7,I07FI0JF8PFBFDFDFFEFFCL0EE,I07F8003OF7JFBFEF9FBFF3CK01CE,I03FCI0TF7FE73FF9FFEK03CC,I03FCI01SF7FF3IF7FDEK03FC,I01FEJ03QFEIF9JF41EK07B8,I01FEK0107JFI01JFCFFDFBDEK0738,J0FFN07FF8J01IFE7FBFBDFK0F7,J07F8M01FEL03IF3F3FB0FJ01E2,J07FCO06M07FF9FFE1BFJ0386,J03FCO03CL01FFDFFDDF78I039C,J01FEX07FEIFDEF8I07F8,J01FFX01FE3FF6CFCI0FB8,K0FF8X03FBFEE3FE001DF,K07FCX01FDFFE7BF003CA,K07FEY03EFFCFBF807CC,K03FEg077F9FDFC07CC,K01FFgG03F3F87C0FC8,L0FF8gG017FFB01EF,L07FCgM03FE,L03FEgM07FC,L01FF8gK01FF8,M0FFCgK03F7,M07FEgK07E6,M03FFgK0FAC,M01FF8gI01FB8,N0FFEgI07FB,N07FFgI0FFE,N03FF8gG01FFC,N01FFEgG07F78,O0IF8Y01FFE,O03FFCY03FFC,O01IFY0IF8,P07FFCW03FDE,P03IFW0FFCC,Q0IFCU03IF,Q07IF8S01IFE,Q01IFES07IF8,R07IFEQ07IFE,R01JFCO03IF78,S07JFEM07JFE,S01LF8I01LF8,T07UFE,U0UF,U01SF8,V03OFBFC,W03FBLFBC,X027FF7IF8,g03IFC,,::^FS
^XZZ`;


        
        
                await fetch('https://rblabelprinter.internal.rebricker.com/pstprnt', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'text/plain'
                    },
                    body: label_image
                });
            }
                        
            if (next)
            {
                
                setCounter(await readNextHu(type))
            }

            //setCounter(counter+1)

            showSnackbar("Daten geschrieben, Label gedruckt", 'success');
    
        }
        catch(error: any)
        {
            console.error('Fetch Error:', error.message); // Logs the error message
        console.error('Error Details:', {
            name: error.name,       // Error name
            message: error.message, // Error message
            stack: error.stack,     // Error stack trace
            response: error.response, // Custom response if available
        });
            showSnackbar(error.message, 'error');
        }
        

       

        // return await CapacitorZebraPrinter.print({
        //     ip,
        //     port,
        //     zpl,
        //   }).then((res:any) => {
        //     return res && res.value == "success";
        //   });


    };

    const onBookHu = async () => {

        const utils = new NfcUtils();
        try
        {

            const tag = await read();

            var hu;

            if (tag.message?.records)
                {
                    for (const record of tag.message?.records) {
                    
                        const text = utils.getTextFromNdefTextRecord({record: record})

                        if (text && text.text?.startsWith("HU"))
                        {
                            hu = text.text
                        }
                    }    
                }

            if (!hu)
            {
                showSnackbar(`Tag gelesen: ${tag.id} Keine HU Information gefunden`, 'error');
                return
            }

            const scanner = await CapacitorBarcodeScanner.scanBarcode({hint: CapacitorBarcodeScannerTypeHint.ALL, cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK })


            setTm(scanner.ScanResult);
            setTm(JSON.stringify({'id':hu}))
            const scannerParts = scanner.ScanResult.split(":");

            if (scannerParts.length < 2)
                {
                    showSnackbar(`Barcode : ${scanner.ScanResult} Keine Stellplatzinfo gefunden`, 'error');
                    return
                }

            const storageType = scannerParts[0]

            const bin = scannerParts[1];

            await axios.post(`https://picturama.rebricker.com/api/warehouse/storageType/${storageType}/${bin}/handlingUnit`,{'id':hu});
            //setCounter(counter+1)

            showSnackbar(`Tag gelesen: ${tag.id} Barcode gelesen ${scanner.ScanResult}`, 'success');
    
        }
        catch(error: any)
        {
            console.error('Fetch Error:', error.message); // Logs the error message
        console.error('Error Details:', {
            name: error.name,       // Error name
            message: error.message, // Error message
            stack: error.stack,     // Error stack trace
            response: error.response, // Custom response if available
        });
            showSnackbar(error.message, 'error');
        }
        

       

        // return await CapacitorZebraPrinter.print({
        //     ip,
        //     port,
        //     zpl,
        //   }).then((res:any) => {
        //     return res && res.value == "success";
        //   });


    };



    const handleTypeChange = async (e: SelectChangeEvent<any>, child: ReactNode) =>  {
        setType(e.target.value);
     
    };

    const handleCounterChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        setCounter(Number(e.target.value));
    };



    return (
        <div className="gap-8 grid h-full w-full bg-lime">

            <div className="bg-white dark:bg-lime-700 h-screen h-full py-6 sm:py-8 lg:py-12">
                <div className="mx-auto max-w-screen-2xl px-4 md:px-8 h-full mt-6">
                    <div className="container">
                        <div className="gap-8 grid h-full w-full  rounded-lg bg-gray-100 shadow-lg p-4">
                            <div className="flex flex-col gap-8">
                            <Select
                                    value={type}
                                    label="Type"
                                    variant="outlined"
                                    onChange={handleTypeChange}
                                >
                                    <MenuItem value={'HUST'}>HUST (HandlingUnit Storage)</MenuItem>
                                    <MenuItem value={'HUSP'}>HUSP (HandlingUnit Spare)</MenuItem>
                                    <MenuItem value={'HUPG'}>HUPG (HandlingUnit Packaging)</MenuItem>
                                </Select>
                                <TextField label="Count" variant="outlined" name="number" type="number" value={counter} onChange={handleCounterChange} />
                      
                                <Button variant="contained" onClick={() => onClick(true, true, true)} disabled={!Capacitor.isNativePlatform()}>Neuen Behälter erstellen (Schreiben + Drucken)</Button>
                                <Button variant="contained" onClick={() => onClick(false,true, false)} disabled={!Capacitor.isNativePlatform()}>Schreiben</Button>
                                <Button variant="contained" onClick={() => onClick(false, false, true)}>Drucken</Button>
                                

                            </div>

                        </div>
                    </div>
                    <p></p>
                    <div className="container">
                        <div className="gap-8 grid h-full w-full  rounded-lg bg-gray-100 shadow-lg p-4">
                            <div className="flex flex-col gap-8">
                                <TextField label="TM" variant="outlined" name="string" type="string" value={tm} />
                      
                                <Button variant="contained" onClick={() => onBookHu()} disabled={!Capacitor.isNativePlatform()}>Behälter  auf Stellplatz buchen</Button>
                     
                                

                            </div>

                        </div>
                    </div>

                </div>

                
                
            </div>    

        </div>
    );
}

export default CreateLabels;
